export const MIN_PIXEL_RATIO = 1;
